import {
  Component,
  AfterViewInit,
} from '@angular/core';

// Options
import { ConfirmationPopoverWindowOptions } from './confirmation-popover-window-options';

/**
 * `ConfirmationPopoverWindowComponent` implements a view for manage a confirmation popover.
 */
@Component({
  styles: [`
    .popover {
      display: block;
    }
  `],
  template: `
    <ng-template #defaultTemplate let-options="options">
      <div [class]="'popover ' + options.placement + ' popover-' + options.placement + ' ' + options.popoverClass">
        <div class="popover-arrow arrow"></div>
        <h3 class="popover-title" [innerHTML]="options.title"></h3>
        <div class="popover-content">
          <p [innerHTML]="options.message"></p>
          <div class="row">
            <div
              class="col-xs-6 col-6"
              [ngClass]="{'col-xs-offset-3 col-offset-3': options.hideCancelButton}"
              *ngIf="!options.hideConfirmButton">
              <button
                [wpFocus]="options.focusButton === 'confirm'"
                [class]="'btn btn-block btn-' + options.confirmButtonType"
                (click)="options.onConfirm({clickEvent: $event})"
                [innerHtml]="options.confirmText">
              </button>
            </div>
            <div
              class="col-xs-6 col-6"
              [ngClass]="{'col-xs-offset-3 col-offset-3': options.hideConfirmButton}"
              *ngIf="!options.hideCancelButton">
              <button
                [wpFocus]="options.focusButton === 'cancel'"
                [class]="'btn btn-block btn-' + options.cancelButtonType"
                (click)="options.onCancel({clickEvent: $event})"
                [innerHtml]="options.cancelText">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template
      [ngTemplateOutlet]="options.customTemplate || defaultTemplate"
      [ngTemplateOutletContext]="{options: options}">
    </ng-template>
  `
})
export class ConfirmationPopoverWindowComponent implements AfterViewInit {
  /**
   * Creates a new `ConfirmationPopoverWindowComponent` instance.
   * @param options Confirmation popover options
   */
  constructor(public options: ConfirmationPopoverWindowOptions) {}

  /**
   * Handles after view init method.
   */
  public ngAfterViewInit(): void {
    this.options.onAfterViewInit();
  }
}
